export function extractLinksFromHTML(html) {
    const parser = new DOMParser()
    const doc = parser.parseFromString(html, 'text/html')
    const links = [...doc.querySelectorAll('a')]

    return links.map((link) => ({
        text: link.textContent?.trim(),
        href: link.getAttribute('href'),
        isUnique: false
    }))
}
